import { render, staticRenderFns } from "./PostEditImmoOfferS.vue?vue&type=template&id=50d6a620&"
import script from "./PostEditImmoOfferS.vue?vue&type=script&lang=js&"
export * from "./PostEditImmoOfferS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports